import api from '../../../services/service'
import moment from 'moment'
import Swal from 'sweetalert2'
// import moment from 'moment'
export default {
  data () {
    return {
      nowDate: moment(new Date()),
      data_detail: {},
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_active: false,
      modal_data: {},
      modal_title: '',
      data_list: [],
      header: {
        'Access-Token': this.$store.state.token
      }
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      return this.data_list.filter(Vendortomer => {
        return (
          Vendortomer.branch_name.indexOf(text) > -1 || Vendortomer.branch_code.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {}
    },
    editVendor (data) {
      this.modal_title = 'แก้ไขข้อมูลปริ้นเตอร์'
      this.modal_active = true
      this.modal_data = data
    },
    getAll () {
      this.$store.commit('Loading')
      api.branchList(
        sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        result => {
          if (result.response === 'success') {
            this.data_list = result.data
            console.log(this.data_list)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    removeHost (code) {
      Swal.fire({
        title: 'ลบข้อมูลเจ้าหนี้',
        text: 'ท่านต้องการลบข้อมูลเจ้าหนี้รหัส ' + code + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          var body = {
            'code': code,
            'active_status': 0
          }
          api.removeHost(sessionStorage.Url,
            this.header,
            body,
            result => {
              if (result.response === 'success') {
                this.getAll()
                this.$notification['success']({
                  message: 'ลบข้อมูลสำเร็จ',
                  description:
                    result.message
                })
              } else {
                this.$notification['warning']({
                  message: 'ลบข้อมูลไม่สำเร็จ',
                  description:
                    result.message
                })
              }
              this.$store.commit('Loading')
            },
            error => {
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        }
      })
    },
    action_modal () {
      if (this.modal_data.host_code === '') {
        alert('ไม่สามารถทำรายการได้')
      } else {
        this.updateHost()
      }
    },
    addHost () {
      this.$store.commit('Loading')
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      api.branchConfigUpdate(
        sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'เพิ่มข้อมูลสำเร็จ',
              description:
                result.message
            })
          } else {
            this.$notification['success']({
              message: 'เพิ่มข้อมูลไม่สำเร็จ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    updateHost () {
      this.$store.commit('Loading')
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      api.branchConfigUpdate(sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'บันทึกข้อมูลสำเร็จ',
              description:
                result.message
            })
          } else {
            this.$notification['success']({
              message: 'บันทึกข้อมูลไม่สำเร็จ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    statusFormat (str) {
      switch (str) {
        case 0:
          return 'ปิด'
        case 1:
          return 'เปิด'
        default:
          return 'n/a'
      }
    },
    changeVal (val) {
      console.log(val)
      if (val === true) {
        this.modal_data.active_status = 1
      }
      if (val === false) {
        this.modal_data.active_status = 0
      }
    },
    openMainItem () {
      this.modal_data = {
        'id': 0,
        'company_id': 0,
        'branch_code': '',
        'branch_name': '',
        'dyn_address': '',
        'access_token': '',
        'active_status': 1
      }
      this.modal_active = true
    }
  },
  mounted () {
    this.getAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/settings/system_branch.js